import Administration from '../../views/Akademi/Administration.view';

export default Administration;
